//#region src/errors/network-error.ts
var e = class extends Error {
	constructor() {
		super(), this.name = this.constructor.name;
	}
};
//#endregion
export { e as NetworkError };
